export function track(type, payload) {
    // (window as any).track(type, payload);
}
